// Mock content data for Train Driver Foundation site

export const siteInfo = {
  company: "Train Driver Foundation",
  companyFull: "UK TRAIN DRIVER ACADEMY LTD",
  tradingName: "Train Driver Foundation (TDF)",
  companyNo: "13240841",
  cpdMembership: "022446",
  ukprn: "10101132",
  email: "trainingteam@traindriverfoundation.com",
  year: new Date().getFullYear(),
  socials: {
    youtube: "http://www.youtube.com/@traindriverfoundation",
    linkedin: "https://linkedin.com/company/train-driver-foundation",
    facebook: "https://www.facebook.com/profile.php?id=61586292017263",
    email: "mailto:trainingteam@traindriverfoundation.com",
  },
};

export const navLinks = [
  { label: "How to Become a Driver", to: "/become-a-driver" },
  { label: "Eligibility", to: "/eligibility" },
  { label: "Careers", to: "/careers" },
  { label: "Online Assessment", to: "/online-assessment" },
  { label: "CV Review", to: "/cv" },
  { label: "Interview Preparation", to: "/interview" },
  { label: "Psychometric Tests", to: "/psychometrics" },
  { label: "CPD Courses", to: "/cpd" },
  { label: "TOCs", to: "/tocs" },
  { label: "Service Leavers", to: "/service-leavers" },
  { label: "Outcomes", to: "/outcomes" },
  { label: "Complete Package", to: "/complete-career-package" },
  { label: "Contact", to: "/contact" },
];

export const heroStats = [
  { value: "1,000+", label: "Customers Trust Us" },
  { value: "High Pass Rate", label: "Results Driven Services" },
  { value: "Over 15", label: "Years Experience" },
];

export const supportPillars = [
  {
    icon: "BookOpen",
    title: "Expert Guidance",
    body:
      "Practical support with train driver online assessments, CVs, interviews, psychometrics and career preparation. Designed and delivered by experienced rail industry professionals who understand what operators look for.",
  },
  {
    icon: "Award",
    title: "Professional Development Courses",
    body:
      "CPD-certified, rail-specific training built around real train driver and rail industry standards, designed to develop the right knowledge, skills, behaviours, and mindset expected by UK rail operators.",
  },
  {
    icon: "Users",
    title: "Proven Success",
    body:
      "Trusted by aspiring drivers preparing for each stage of the train driver recruitment process, from initial applications through to assessments, interviews and professional development.",
  },
  {
    icon: "TrendingUp",
    title: "Career Growth",
    body:
      "Ongoing support, resources, and structured development to help you progress beyond recruitment and build a long-term, successful career in the UK railway industry.",
  },
];

export const serviceCards = [
  {
    title: "Improving CV Success",
    tagline: "Over 91% of applicants are rejected at CV stage. Don’t be one of them.",
    bullets: [
      "Professional CV review by recruiting managers",
      "Industry-specific tailoring and improvements",
      "Stand out from the competition",
    ],
    cta: "CV Review Service",
    to: "/cv",
  },
  {
    title: "Interview Success",
    tagline:
      "Train driver interviews are structured, safety-focused and highly competitive. Prepare with confidence.",
    bullets: [
      "Guidance for MMI/CBI and DMI Interviews",
      "STAR examples linked to railway safety behaviours",
      "Build confident, structured answers that stand out",
    ],
    cta: "Interview Preparation",
    to: "/interview",
  },
  {
    title: "Personal Development",
    tagline:
      "Build relevant knowledge and skills before applying. Invest in your own career development.",
    bullets: [
      "CPD-certified training aligned to train driver standards",
      "Structured learning across safety, rules and railway knowledge",
      "Enhances your application",
    ],
    cta: "View CPD Courses",
    to: "/cpd",
  },
  {
    title: "Psychometric Mastery",
    tagline:
      "Train driver psychometric assessments test focus, accuracy, memory and safety-critical thinking.",
    bullets: [
      "Practice across all key train driver assessment areas",
      "Improve speed, accuracy and confidence over time",
      "Prepare ethically with structured, skill-based practice",
    ],
    cta: "Psychometric Practice",
    to: "/psychometrics",
  },
];

export const testimonials = [
  {
    initial: "T",
    name: "Tom",
    role: "Verified Trustpilot Review · 5 days ago",
    title: "Great and helpful information",
    quote:
      "Great and helpful information. Great insight into specific requirements for operational railway roles.",
  },
  {
    initial: "D",
    name: "Daniel Manning",
    role: "Verified Trustpilot Review · 6 days ago",
    title: "Used their CV reviewing service",
    quote:
      "Used their CV reviewing service for a trainee driver application and it helped me make the sift and get the job. Prompt replies along with tips and guidance for the application. Would definitely recommend using if you're interested in working on the railway, particularly driving. Thanks again.",
  },
  {
    initial: "G",
    name: "Gordon Roberts",
    role: "Verified Trustpilot Review · 1 week ago",
    title: "Train Driver CV and Application",
    quote:
      "The help and support I received from TDF has been first class. They assisted me with my CV, applications, and interview preparation throughout the process. Following their guidance, I've gone on to pursue my career in Train Driving.",
  },
];

export const trustpilot = {
  url: "https://www.trustpilot.com/review/traindriverfoundation.com",
  rating: 4.2,
  ratingLabel: "Great",
  reviewCount: 3,
};

export const becomeDriverStats = [
  { value: "Less than 1%", label: "Average application success rate" },
  { value: "9-12 months", label: "Training duration" },
  { value: "£27k-£33k", label: "Starting salary" },
  { value: "£48k-£68k", label: "Qualified salary" },
  { value: "Shifts, nights, weekends", label: "Work pattern" },
  { value: "Instructor / Management", label: "Career progression" },
];

export const journeySteps = [
  { title: "Research", text: "Understand the role, the industry and what's expected of a safety-critical train driver." },
  { title: "Check Eligibility", text: "Confirm you meet age, medical, vision and right-to-work requirements." },
  { title: "Prepare Your CV", text: "Tailor a railway-ready CV that demonstrates safety behaviours and transferable skills." },
  { title: "Find Vacancies", text: "Monitor TOC and FOC career pages within 45–60 minutes of your home." },
  { title: "Interviews", text: "Succeed at both MMI/CBI and DMI interviews." },
  { title: "Psychometric Tests", text: "Pass concentration, reaction, perception, memory and vigilance assessments." },
  { title: "Medical", text: "Complete rigorous medicals including vision, hearing and general fitness." },
  { title: "Begin Training", text: "Start 9–12 months of classroom, traction, rules and practical route training." },
];

export const becomeDriverFAQ = [
  {
    q: "How do I become a train driver in the UK?",
    a: "To become a train driver in the UK, you normally apply for a trainee train driver vacancy with a Train Operating Company, Freight Operating Company, metro operator or rail organisation. The recruitment process usually includes an application, CV sift, online assessment, psychometric testing, interviews, medical checks and formal driver training. Start with our Become a Driver guide, then use the CV Review Service, Online Assessment Preparation Tool, Psychometric Practice Platform and Interview Preparation pages to prepare each stage properly.",
  },
  {
    q: "What qualifications do I need to become a train driver?",
    a: "Requirements vary between operators, but trainee train driver applicants usually need a good standard of English, maths, communication and concentration. Some employers ask for GCSEs or equivalent, while others focus more on aptitude, safety behaviours and suitability for training. Our Eligibility page helps you check the main requirements before you spend time applying.",
  },
  {
    q: "Do I need railway experience to become a train driver?",
    a: "No. Many successful applicants come from outside the railway. What matters is showing transferable evidence of safety awareness, rule-following, concentration, communication, reliability and calm decision-making. Our CV Review Service can help you translate non-rail experience into railway-relevant evidence, while our CPD Courses can help you build stronger rail-specific knowledge before applying.",
  },
  {
    q: "Why is train driver recruitment so competitive?",
    a: "Train driver roles attract very high numbers of applicants because they offer strong salaries, structured training and long-term career stability. Many candidates fail early because their CV is too generic, they are unfamiliar with online assessments, or they underestimate the psychometric and interview stages. This is why Train Driver Foundation separates preparation into CV, online assessment, psychometric, interview and CPD support.",
  },
  {
    q: "What stage do most trainee train driver applicants fail?",
    a: "Many applicants fail early at the CV sift or online assessment stage before they ever reach psychometric testing or interview. Others fail later because they have not practised under assessment conditions or cannot structure safety-critical interview examples clearly. If you are applying soon, the Complete Career Package is the most structured way to prepare across several key stages.",
  },
  {
    q: "What does a train driver actually do?",
    a: "A train driver operates trains safely, punctually and professionally. The role involves following signals, speed limits, railway rules, operational instructions and company procedures. Drivers also prepare trains for service, maintain concentration, communicate with signallers and control, and make safety-critical decisions. Our CPD Courses help applicants understand the role beyond the basic job advert.",
  },
  {
    q: "What skills are train companies looking for?",
    a: "Train companies look for safety awareness, concentration, rule-following, communication, reliability, professionalism and responsibility. These skills must be evidenced through examples, not just listed. This is why preparation at the CV and interview stages matters. Our CV Review Service and Interview Preparation resources are built around these behaviours.",
  },
  {
    q: "How important is my CV when applying for trainee train driver jobs?",
    a: "Your CV is extremely important because it is often the first major sift. A strong train driver CV should be clear, relevant and focused on safety-critical behaviours. If your CV does not show the right evidence, you may be rejected before reaching assessments. Our CV Review Service helps identify weak wording, missing evidence and poor structure before you apply.",
  },
  {
    q: "What is the train driver online assessment stage?",
    a: "The online assessment is commonly used early in recruitment to screen applicants. It may include attention to detail, data checking, situational judgement, behavioural questions and safety-focused scenarios. Our Online Assessment Preparation Tool helps applicants understand this early stage before they face a live recruitment test.",
  },
  {
    q: "What are train driver psychometric tests?",
    a: "Train driver psychometric tests assess aptitudes linked to safety-critical train driving, including concentration, memory, attention, reaction, coordination, perception, judgement and communication. Familiarisation and structured practice can help improve confidence and consistency. Our Psychometric Practice Platform is designed specifically for train driver assessment preparation.",
  },
  {
    q: "What is the MMI in train driver recruitment?",
    a: "The MMI, or Multi-Modal Interview, is a structured interview exploring examples linked to concentration, rule-following, communication, pressure, safety and responsibility. Strong answers are usually evidence-based and structured using STAR. Our Interview Preparation guidance helps applicants build stronger examples before the real interview.",
  },
  {
    q: "What is the DMI in train driver recruitment?",
    a: "The DMI, or Driver Manager Interview, is usually a later-stage interview with operational managers. It assesses motivation, understanding of the role, safety mindset, professionalism, customer awareness and suitability for training. Our Interview Preparation resources cover both MMI/CBI-style answers and DMI-style suitability questions.",
  },
  {
    q: "When do trainee train driver jobs open?",
    a: "Trainee train driver vacancies do not follow one national timetable. Operators recruit when they need trainees, and vacancies can open and close quickly. You should monitor individual Train Operating Company career pages and use our Careers and TOCs pages to understand where opportunities may appear.",
  },
  {
    q: "How far from home can I apply for trainee train driver jobs?",
    a: "Most operators expect applicants to live within a reasonable travelling distance of the depot, often because of early starts, late finishes, fatigue risk and emergency availability. The exact distance varies by employer and depot. Before applying, check the vacancy advert carefully and use our TOCs page to research operators and depot locations.",
  },
  {
    q: "Is it worth doing a course before applying to become a train driver?",
    a: "A course will not guarantee a job, but structured learning can help you understand the role, build rail-specific knowledge and speak more confidently about safety, rules, procedures and the railway environment. Our CPD Courses are designed for applicants who want stronger preparation before applying.",
  },
  {
    q: "How do I stand out from other trainee train driver applicants?",
    a: "You stand out by showing evidence, not by making generic claims. Your CV should demonstrate safety-critical behaviours, your assessments should show accuracy and consistency, and your interview answers should prove that you understand the role. The Complete Career Package brings together key preparation resources for applicants who want a more structured approach.",
  },
  {
    q: "How long does train driver training take?",
    a: "Train driver training often takes around 9 to 12 months, depending on operator, route, traction and trainee progress. It includes classroom learning, rules, traction, route learning, practical handling, assessments and final competence checks. Our CPD Courses can help applicants understand some of the professional expectations before formal training begins.",
  },
  {
    q: "Is becoming a train driver difficult?",
    a: "Yes. The recruitment process is competitive and training is demanding. Candidates need concentration, patience, discipline, resilience, safety awareness and the ability to absorb large amounts of technical and operational information. Preparation does not guarantee success, but it can reduce avoidable mistakes at each stage.",
  },
  {
    q: "What is the best way to prepare before applying?",
    a: "The best approach is to understand the role first, then prepare each recruitment stage separately: eligibility, CV, online assessment, psychometrics and interviews. Our Complete Career Package brings several of these preparation stages together for applicants who want structured support before applying.",
  },
  {
    q: "Will TDF guarantee I get a train driver job?",
    a: "No. No genuine provider can guarantee a train driver job because recruitment decisions are made by employers. Train Driver Foundation helps applicants reduce avoidable mistakes, understand the process and prepare more professionally for CV sifts, online assessments, psychometrics, interviews and career development.",
  },
];

export const cvFAQ = [
  {
    q: "How do I write a CV for a trainee train driver job?",
    a: "A strong trainee train driver CV should focus on safety-critical behaviours, not just previous job duties. Train operators want evidence that you can follow rules, concentrate for long periods, communicate clearly, remain calm under pressure and make responsible decisions. Your CV should be clear, structured, evidence-based and tailored to the train driver role. Our CV Review Service is designed to check exactly this.",
  },
  {
    q: "What do train companies look for in a train driver CV?",
    a: "Train companies look for transferable evidence of safety awareness, concentration, rule-following, communication, reliability and responsibility. You do not always need railway experience, but your CV must show that your background has prepared you for a safety-critical role. Our CV Review Service is built around these railway-specific behaviours.",
  },
  {
    q: "Do I need railway experience to apply for a trainee train driver role?",
    a: "No. Many successful trainee train driver applicants come from non-rail backgrounds such as retail, logistics, emergency services, military, transport, customer service and operational roles. The key is explaining your transferable experience in a way that matches what train operators assess. Our CV Review Service helps applicants make that link clearly.",
  },
  {
    q: "Why do most trainee train driver CVs get rejected?",
    a: "Most CVs are rejected because they are too generic, list duties instead of evidence, lack safety-critical examples, or fail to show the behaviours train operators are looking for. A candidate may have good experience but still fail the sift if the CV does not present that experience clearly. This is one of the main problems our CV Review Service is designed to fix.",
  },
  {
    q: "How long should a trainee train driver CV be?",
    a: "A trainee train driver CV should usually be no more than two pages. It needs enough detail to evidence your suitability, but it must also be easy for recruiters to scan quickly. Clear sections, concise bullet points and relevant examples are more effective than long paragraphs.",
  },
  {
    q: "What skills should I include on a train driver CV?",
    a: "Useful skills to evidence include attention to detail, concentration, following procedures, safety awareness, communication, decision-making, responsibility, reliability and working calmly under pressure. Avoid simply listing these skills; use short examples that show how you have demonstrated them. Our CV Review Service checks whether these behaviours are clear enough.",
  },
  {
    q: "Can I use AI to write my train driver CV?",
    a: "AI can help with structure and wording, but it should not invent experience or produce generic claims. Train driver recruitment is evidence-based, so your CV must reflect your real background. Our Instant CV Checker can highlight gaps and improve structure, while our Expert Human Review provides railway-specific feedback from a recruitment perspective.",
  },
  {
    q: "What is an ATS and does it affect train driver applications?",
    a: "An ATS, or Applicant Tracking System, is software that helps employers manage and filter applications. Some railway employers may use systems that scan for structure, keywords and relevant information. A clear, well-structured CV with relevant rail and safety language is usually safer than a heavily designed CV. Our CV Review Service checks for clarity, structure and role relevance.",
  },
  {
    q: "What keywords should I include in a train driver CV?",
    a: "Relevant wording may include safety-critical, procedures, risk awareness, communication, concentration, attention to detail, responsibility, compliance and decision-making. However, keywords alone are not enough. They must be supported by real examples from your work or life experience.",
  },
  {
    q: "Should I include a personal profile on a train driver CV?",
    a: "Yes, but keep it concise. A good profile should briefly explain your suitability for a safety-critical role and introduce the behaviours you evidence later in the CV. Avoid generic phrases such as hardworking, passionate or team player unless they are supported by examples.",
  },
  {
    q: "Should I tailor my CV for every train driver application?",
    a: "Yes. Each operator may describe the role slightly differently, so your CV should reflect the wording and priorities in the vacancy advert. You do not need to rewrite everything, but you should check that your most relevant evidence is clear and easy to find.",
  },
  {
    q: "What should I avoid in a train driver CV?",
    a: "Avoid vague claims, unexplained employment gaps, spelling errors, over-designed layouts, irrelevant detail and long lists of duties. The biggest mistake is failing to connect your experience to the behaviours train operators assess. A CV Review can identify these problems before you submit an application.",
  },
  {
    q: "Is it worth getting my train driver CV professionally reviewed?",
    a: "For many applicants, yes. A professional review can identify weak wording, missing evidence, poor structure and missed opportunities. TDF offers both an Instant CV Checker for quick feedback and an Expert Human Review for applicants who want detailed railway-specific support.",
  },
  {
    q: "Can a good CV help me pass the rest of the process?",
    a: "A good CV will not pass the online assessment, psychometric tests or interviews for you, but it can help you get through the first sift and create stronger evidence for later stages. Many of the same safety behaviours used in your CV will also appear in interview questions, so CV preparation often supports Interview Preparation as well.",
  },
  {
    q: "What happens after the CV stage?",
    a: "If your CV is successful, you may be invited to complete online assessments, psychometric testing, interviews and a medical. Each stage tests different skills, so passing the CV sift is only the first part of the recruitment process. Our Online Assessment Preparation Tool, Psychometric Practice Platform and Interview Preparation resources support the next stages.",
  },
];

export const interviewFAQ = [
  {
    q: "What interviews are used in trainee train driver recruitment?",
    a: "Train driver recruitment commonly includes structured interviews such as the MMI, or Multi-Modal Interview, and the DMI, or Driver Manager Interview. Some operators may also use competency-based questions, values-based questions or safety-focused scenario questions. Our Interview Preparation resources cover the main interview styles used in train driver recruitment.",
  },
  {
    q: "What is the difference between the MMI and DMI?",
    a: "The MMI is usually a structured, evidence-based interview focused on past behaviour, such as concentration, communication, rule-following and pressure. The DMI is usually a later interview with operational managers, assessing motivation, understanding of the role, professionalism and safety mindset. Both require preparation, but they assess different things.",
  },
  {
    q: "How should I answer train driver interview questions?",
    a: "Use clear, specific examples and structure your answer logically. STAR — Situation, Task, Action, Result — is useful because it helps you explain what happened, what you personally did and what the outcome was. Our Interview Preparation material is built around this type of structured evidence.",
  },
  {
    q: "What do train driver interviewers look for?",
    a: "Interviewers look for evidence of safety awareness, concentration, rule-following, communication, decision-making, honesty, professionalism and personal responsibility. They are not just assessing what you say; they are assessing whether your examples show suitable behaviours for a safety-critical role.",
  },
  {
    q: "What are common train driver interview mistakes?",
    a: "Common mistakes include giving vague examples, speaking in general terms, failing to explain personal actions, choosing examples that do not match the question, exaggerating experience, or showing limited understanding of the train driver role. Our Interview Preparation resources help applicants avoid these issues before the real interview.",
  },
  {
    q: "Can I use examples from outside the railway?",
    a: "Yes. Many strong answers come from non-rail roles. Examples from customer service, logistics, emergency services, military, aviation, security, healthcare, engineering and operational environments can all be useful if they demonstrate the right behaviours. The key is linking your example to safety-critical train driver behaviours.",
  },
  {
    q: "What questions are asked in a Driver Manager Interview?",
    a: "A Driver Manager Interview may cover your motivation, understanding of the role, safety mindset, shift work, dealing with pressure, communication, following rules and why you want to work for that operator. You should be ready to show realistic understanding, not just enthusiasm. Our Interview Preparation guidance helps you prepare for this style of questioning.",
  },
  {
    q: "What questions are asked in the MMI?",
    a: "MMI questions often ask for examples of concentration, dealing with an emergency, following rules, working under pressure, communicating clearly or taking responsibility. The assessor usually probes your answer to understand exactly what you did and why. Practising structured STAR examples before the interview is essential.",
  },
  {
    q: "How much preparation should I do before a train driver interview?",
    a: "You should prepare thoroughly, but avoid memorising scripted answers. Build a bank of genuine examples, understand the behaviours being assessed and practise explaining your actions clearly. TDF’s Interview Preparation guidance helps applicants structure this preparation properly.",
  },
  {
    q: "Can I fail the interview even if I have good experience?",
    a: "Yes. Strong experience does not always translate into a strong interview answer. Candidates often fail because they do not structure their examples clearly, miss the behaviour being assessed or fail to show personal responsibility. Interview preparation helps convert real experience into stronger evidence.",
  },
  {
    q: "Should I memorise answers for a train driver interview?",
    a: "No. Memorised answers often sound scripted and can fall apart when the assessor probes for detail. You should understand your examples, practise the structure and know the key behaviours you are trying to evidence. Our Interview Preparation resources help you build flexible answers rather than fixed scripts.",
  },
  {
    q: "How do I prepare examples for a train driver interview?",
    a: "Start by identifying examples where you followed rules, managed pressure, stayed focused, communicated clearly, dealt with risk or took responsibility. Then structure each example using STAR and check that your personal actions are clear. If your examples are weak or vague, our Interview Preparation support can help you improve them.",
  },
];

export const psychometricFAQ = [
  {
    q: "What are train driver psychometric tests?",
    a: "Train driver psychometric tests assess the aptitudes required for safe train operation. These can include concentration, attention, reaction time, memory, perception, coordination, reasoning, communication and vigilance. Our Psychometric Practice Platform helps applicants familiarise themselves with these skill areas before assessment.",
  },
  {
    q: "Can you prepare for train driver psychometric tests?",
    a: "Yes. You cannot ethically memorise exact test answers, but you can improve familiarity, concentration, accuracy, consistency and confidence. Structured practice helps reduce avoidable mistakes and improves performance under time pressure. Our Psychometric Practice Platform is designed for this type of preparation.",
  },
  {
    q: "What is the Group Bourdon test?",
    a: "The Group Bourdon test is a concentration and attention test where candidates identify specific patterns quickly and accurately. It is not about rushing; it is about maintaining speed, accuracy and consistency over time. Regular practice can help you understand the level of focus required.",
  },
  {
    q: "What is the TEA-Occ test?",
    a: "TEA-Occ refers to occupational attention testing. It assesses how well a candidate can focus, switch attention or divide attention depending on the task. These abilities are important in safety-critical train driving and are covered as part of structured psychometric preparation.",
  },
  {
    q: "What is the WAFV vigilance test?",
    a: "A vigilance test measures your ability to maintain attention over time and respond to important but infrequent signals. This is relevant to train driving because drivers must remain alert during long periods of routine operation. Our Psychometric Practice Platform includes vigilance-style preparation.",
  },
  {
    q: "What is tested in train driver memory assessments?",
    a: "Memory assessments may examine your ability to absorb, retain and apply information. This reflects the need to learn rules, procedures, traction knowledge, route information and operational instructions during training. Our practice platform helps applicants build familiarity with memory-based assessment demands.",
  },
  {
    q: "Are train driver psychometric tests hard?",
    a: "They can be challenging because they test consistency, not just ability. Many candidates make errors because they rush, lose focus or become anxious. Practice helps you understand the demands and develop a calmer, more consistent approach.",
  },
  {
    q: "How many times can I take train driver psychometric tests?",
    a: "Retake rules vary between operators and assessment providers. Some failures may count nationally or limit future attempts for a period of time, so applicants should take the assessments seriously and prepare before attending. This is why structured psychometric practice is important before your real assessment.",
  },
  {
    q: "What is the best way to practise psychometric tests?",
    a: "The best approach is regular, timed, focused practice across the skill areas being assessed: attention, reaction, memory, vigilance, reasoning and perception. Our Psychometric Practice Platform is designed for structured familiarisation rather than memorising answers.",
  },
  {
    q: "Can psychometric practice guarantee a pass?",
    a: "No. No genuine provider can guarantee a pass because assessment decisions are made by the employer or assessment centre. Good preparation can improve familiarity, reduce anxiety and help you avoid common mistakes.",
  },
  {
    q: "Should I practise before being invited to psychometric tests?",
    a: "Yes. Waiting until you receive an assessment invitation can leave very little time to prepare. Because retake rules can be strict, it is sensible to start building familiarity early. Our Psychometric Practice Platform is designed for applicants who want to prepare before they are under time pressure.",
  },
  {
    q: "What happens after psychometric testing?",
    a: "If you pass the required psychometric assessments, you may progress to interviews such as the MMI, CBI or DMI, depending on the operator. These interviews test evidence, motivation, safety mindset and suitability. Our Interview Preparation resources support the next stage after psychometrics.",
  },
];

export const psychometricTests = [
  { title: "Attention", body: "Selective — differentiating between sources and attending selectively. Divided — switching attention between sources.", skills: ["Selective attention", "Divided attention", "Information processing"] },
  { title: "Behavioural", body: "No established occupational psychological deficiencies, particularly in operational aptitudes or relevant personality factors.", skills: ["Emotional stability", "Stress management", "Professional conduct"] },
  { title: "Communication", body: "Reading, listening, understanding and responding appropriately in writing and speech.", skills: ["Reading comprehension", "Verbal communication", "Written expression"] },
  { title: "Hand Coordination", body: "Controlled movements in response to decisions about complex stimuli.", skills: ["Motor control", "Reaction accuracy", "Physical coordination"] },
  { title: "Memory", body: "Ability to learn, recall and apply job-related information within time limits.", skills: ["Information retention", "Procedural recall", "Applied learning"] },
  { title: "Perception", body: "Anticipating elements in a traffic environment and responding at speed and distance.", skills: ["Visual processing", "Situational awareness", "Anticipation"] },
  { title: "Reaction Time", body: "Quick, adequate responses to visual and acoustic stimuli.", skills: ["Quick responses", "Stimulus recognition", "Performance quality"] },
  { title: "Reasoning", body: "Solving problems and making decisions — fault diagnosis, interpreting instrumentation.", skills: ["Problem solving", "Logical thinking", "Decision making"] },
  { title: "Vigilance", body: "Attending to stimuli that occur relatively infrequently over extended periods.", skills: ["Sustained attention", "Long-term focus", "Rare event detection"] },
];

export const cpdCourses = [
  {
    title: "Train Driving — Pre-Employment Training (PET) — Intermediate",
    hours: "CPD 40 Hours",
    price: "£289.00",
    description: "Industry-leading pre-employment training course for aspiring trainee train drivers or those already in the industry looking to change role.",
    featured: true,
  },
  {
    title: "Personal Track Safety (PTS) — Introduction",
    hours: "CPD 15 Hours",
    price: "£189.99",
    description: "Essential course for working safely on or near the railway. Learn the fundamentals of personal track safety.",
  },
  {
    title: "Traction and Rolling Stock — Introduction",
    hours: "CPD 15 Hours",
    price: "£189.99",
    description: "Learn the fundamentals of train systems and operations. Perfect foundation for aspiring train drivers.",
  },
  {
    title: "Train Driving — Introduction",
    hours: "CPD 15 Hours",
    price: "£189.99",
    description: "Introduction to the principles and practices of train driving. Build your knowledge before applying.",
  },
  {
    title: "How to Become a Train Driver",
    hours: "Guide",
    price: "£49.99",
    description: "Step-by-step guide to joining the UK railway industry as a trainee train driver. Understand the complete recruitment process.",
  },
];

export const products = [
  { title: "Complete Career Package", was: "£453.95", price: "£376.99", save: "Save 17%" },
  { title: "Full Application Pack", was: "£164.95", price: "£121.99", save: "Save 26%" },
  { title: "CV Review Service", price: "£49.99" },
  { title: "Detailed Interview Guidance", price: "£19.99" },
  { title: "Psychometric Assessment Guide & Practice Platform", price: "£24.99" },
  { title: "Online Assessment Preparation Tool", price: "£7.99" },
  { title: "Train Driver PET — Intermediate (CPD 40 Hours)", price: "£289.00" },
  { title: "Train Driving — Introduction", price: "£189.99" },
  { title: "Traction and Rolling Stock — Introduction", price: "£189.99" },
  { title: "Personal Track Safety (PTS) — Introduction", price: "£189.99" },
];

export const tocs = [
  { name: "Avanti West Coast", url: "https://www.careers.avantiwestcoast.co.uk/" },
  { name: "c2c", url: "https://www.c2c-online.co.uk/careers-at-c2c/" },
  { name: "Chiltern Railways", url: "https://ce0834li.webitrent.com/ce0834li_webrecruitment/wrd/run/ETREC179GF.open?WVID=68317141Hv" },
  { name: "CrossCountry", url: "https://www.crosscountrytrains.co.uk/crosscountry-careers" },
  { name: "East Midlands Railway", url: "https://www.eastmidlandsrailway.co.uk/help-manage/about-us/job-vacancies" },
  { name: "Elizabeth Line", url: "https://careers.gtsr.co.uk/jobs/vacancy/find/results/" },
  { name: "Gatwick Express", url: "https://www.gtrailwaycareers.com/jobs/home/" },
  { name: "Grand Central", url: "https://www.grandcentralrail.com/careers-grand-central" },
  { name: "Great Northern", url: "https://www.gtrailwaycareers.com/jobs/vacancy/find/results/" },
  { name: "Great Western Railway", url: "https://www.gwr.com/about-gwr/careers" },
  { name: "Greater Anglia", url: "https://apply.greateranglia.co.uk/" },
  { name: "Heathrow Express", url: "https://www.heathrowexpress.com/careers-at-heathrow-express" },
  { name: "Hull Trains", url: "https://careers.firstgroup.co.uk/brand-hulltrains" },
  { name: "LNER", url: "https://www.lnerjobs.co.uk/jobs/vacancy/find/results/" },
  { name: "London Northwestern Railway", url: "https://wmtrains.pinpointhq.com/" },
  { name: "Merseyrail", url: "https://careers.merseyrail.org/#js-careers-jobs-block" },
  { name: "Northern", url: "https://www.northernrailway.co.uk/careers" },
  { name: "ScotRail", url: "https://apply.scotrail.co.uk/vacancies/" },
  { name: "South Western Railway", url: "https://careers.southwesternrailway.com/jobs/search" },
  { name: "Southeastern", url: "https://www.southeasternrailway.co.uk/about-us/company/careers-at-southeastern" },
  { name: "Southern", url: "https://www.gtrailwaycareers.com/jobs/vacancy/find/results/" },
  { name: "Thameslink", url: "https://www.gtrailwaycareers.com/jobs/vacancy/find/results/" },
  { name: "TransPennine Express", url: "https://www.tpexpresscareers.co.uk/tpe/home" },
  { name: "Transport for Wales", url: "https://jobs.tfw.wales/jobs/vacancy/find/results/" },
  { name: "West Midlands Railway", url: "https://www.westmidlandsrailway.co.uk/about-us/careers" },
];

export const images = {
  heroTrain: "https://images.unsplash.com/photo-1680992843731-6a036f788f82?auto=format&fit=crop&w=1600&q=80",
  stationPlatform: "https://images.unsplash.com/photo-1693411267248-aa88e1c0d53b?auto=format&fit=crop&w=1600&q=80",
  yellowTrain: "https://images.unsplash.com/photo-1697099816119-5f88b397a4f0?auto=format&fit=crop&w=1600&q=80",
  silverTrain: "https://images.unsplash.com/photo-1693411468002-9446c9dde34e?auto=format&fit=crop&w=1600&q=80",
  cabDriver: "https://images.unsplash.com/photo-1760344967947-f1744b592779?auto=format&fit=crop&w=1600&q=80",
  conductor: "https://images.pexels.com/photos/34278031/pexels-photo-34278031.jpeg",
  controlPanel: "https://images.pexels.com/photos/35592177/pexels-photo-35592177.jpeg",
  platform: "https://images.unsplash.com/photo-1556916467-58dbe675c06f?auto=format&fit=crop&w=1600&q=80",
};